// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const articleActions = require('client-v2/common/models/article/actions')
const collectionActions = require('client-v2/common/models/collection/actions')
const userActions = require('client-v2/common/models/user/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
// Sibling imports
const { defaultFeedActions } = require('./actions')
const createAppPromoCardSelectors = require('./app-promo-card-selectors')
const Feed = require('./component-dumb')
const { defaultFeedSelectors } = require('./selectors')

module.exports = {
  createFeedSmartComponent,
  defaultFeedSmartComponent: createFeedSmartComponent(defaultFeedActions, defaultFeedSelectors)
}

function createFeedSmartComponent(feedActions, feedSelectors) {

  const appPromoCardSelectors = createAppPromoCardSelectors(feedSelectors)

  function mapStateToProps(state) {
    const { user } = state
    return {
      // Flags
      isMoreAvailable: feedSelectors.getIsNextPageAvailable(state),
      // Values
      items: appPromoCardSelectors.getDenormalizedItems(state),
      selfUserId: user.loggedIn ? user.id : undefined
    }
  }

  function mapDispatchToProps(dispatch) {
    const { dispatchAction, dispatchAuthRequiredAction } = deferDispatch(dispatch)

    function showArticleProfileModal(options) {
      if (options.event && options.event.altKey) {
        return articleActions.navigateToArticleProfile(options)
      }
      return feedActions.showArticleProfileModal(options)
    }

    return {
      onArticleAddClick: dispatchAuthRequiredAction(
        articleActions.handleArticleAddAction,
        authModalActions.showSignup
      ),
      onArticleCardClick: dispatchAction(articleActions.navigateToArticleContent),
      onArticleCountClick: dispatchAction(showArticleProfileModal),
      onArticleDomainClick: dispatchAction(articleActions.navigateToArticleDomainSearch),
      onArticleEmbedDisclose: dispatchAction(articleActions.trackCardView),
      onArticleMoreClick: dispatchAuthRequiredAction(
        articleActions.showArticleActionsModal,
        authModalActions.showSignup
      ),
      onArticlePreviewClick: dispatchAction(showArticleProfileModal),
      onArticleSeen: dispatchAction(articleActions.trackGridView),
      onArticleShareClick: dispatchAction(articleActions.showArticleShareModal),
      onCollectionCardClick: dispatchAction(collectionActions.navigateToCollectionProfile),
      onCollectionPostCountClick: dispatchAction(collectionActions.navigateToCollectionProfilePosts),
      onCollectionShareClick: dispatchAction(collectionActions.showCollectionShareModal),
      onCollectionSubscribeClick: dispatchAuthRequiredAction(
        collectionActions.toggleFollowing,
        authModalActions.showSignup
      ),
      onCollectionSubscriberCountClick: dispatchAction(collectionActions.navigateToCollectionProfileSubscribers),
      onCollectionUserClick: dispatchAction(collectionActions.navigateToCollectionUserProfile),
      onMoreClick: dispatchAction(feedActions.loadMore),
      onUserCardClick: dispatchAction(userActions.navigateToUserProfile),
      onUserFollowClick: dispatchAuthRequiredAction(
        userActions.toggleFollowing,
        authModalActions.showSignup
      ),
      onUserFollowerCountClick: dispatchAction(userActions.navigateToUserProfileFollowers)
    }
  }

  const defaultSmartComponent = (
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(
      withImmutableToJS(
        Feed
      )
    )
  )

  return {
    default: defaultSmartComponent,
    mapStateToProps,
    mapDispatchToProps
  }
}
